import classNames from "classnames";

import { ModalContent } from "src/app/components/modal/types";

import modalCSS from "./Modal.module.css";

const DeleteModal = ({
  close,
  deleteEntity,
  modalContent,
}: {
  close: (isOpen: boolean) => void;
  deleteEntity: (entityId: number) => void;
  modalContent: ModalContent;
}) => {
  return (
    <div className={classNames("u-block", "u-pos-fixed", "u-z-index10", "u-w100", "u-h100 ", "u-bg-black", "u-bg-black-light", modalCSS.modal)}>
      <div className={classNames("u-h8", modalCSS.modalContentDelete)}>
        <div className="u-flex u-col12 u-flex-items-start u-flex-column">
          <div className={classNames(modalCSS.infoTxt)}>
            <h3 className="u-t-primary-dark u-m0 u-mb25px">{modalContent.header}</h3>
            <p className="u-t-black  u-m0 u-mb40px">
              {modalContent.text} <span className="u-t-primary">{modalContent.highlightedText}?</span>
            </p>
          </div>
          <div className={modalCSS.deleteBtnCont}>
            <button onClick={() => close(false)} className={classNames("u-t-uppercase", "u-cursor-pointer", modalCSS.giveupBtn)}>
              odustani
            </button>
            <button onClick={() => deleteEntity(Number(modalContent.entityId))} className={classNames("u-t-uppercase", "u-cursor-pointer", modalCSS.deleteBtn)}>
              izbriši
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
